// extracted by mini-css-extract-plugin
export default {"sectionClientsTable":"PhysiciansShow_sectionClientsTable__HCxAj","tableWrap":"PhysiciansShow_tableWrap__arCxK"};